import { CommonResponse } from '@gtpl/shared-models/masters';
import { GrnRequest, RMVehicleInfoResponse } from '@gtpl/shared-models/raw-material-procurement';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import axios from 'axios';
import { IsNull } from 'typeorm';
import { RMGrnItemIdReq } from '../dto/grn-item-id.request';
import { GrnVehicleInspectionInfo } from '../dto/grn-vehicle.dto';
import { VehicleInspectionService } from './vehicle-inspection.service';
@ApiTags('Vehicle Inspection')
@Controller('vehicle-inspection')
export class VehicleInspectionController {
    constructor(
        private vIService: VehicleInspectionService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
      ) { }

      @Post('/createVehicleInspectionInfo')
      async createVehicleInspectionInfo(@Body() inspectionInfo:GrnVehicleInspectionInfo):Promise<CommonResponse>{
        try {
            return await this.vIService.createVehicleInspectionInfo(inspectionInfo);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
          }
      }
      @Post('/getVehicleInspectionInfo')
      async getVehicleInspectionInfo(@Body() req:RMGrnItemIdReq):Promise<CommonResponse>{
        try {
            return await this.vIService.getVehicleInspectionInfo(req);
          } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
          }
      }

      
}
